export class UserPrivilegeDTO {
  public lastUpdatedUser: string;
  public page1: string ;
  public section1: string;
  public subSection1: string;
  public userRole: string;
  public url: string;


  constructor(lastUpdatedUser: string, page1: string, section1: string, subSection1: string, userRole: string, url: string) {
    this.lastUpdatedUser = lastUpdatedUser;
    this.page1 = page1;
    this.section1 = section1;
    this.subSection1 = subSection1;
    this.userRole = userRole;
    this.url = url;
  }
}
